const PaymentStatus = {
  unpaid: "UNPAID",
  paid: "PAID",
};
export default PaymentStatus;
